module.exports = __webpack_public_path__ + "media/images/gallery/constellations/cassiopeia/cas_vis-01831ac09d58037d9532c8a1e701fb06.jpg";